module.exports = __webpack_public_path__ + "static/media/about_us.3df8feee.svg";